import { get } from "lodash-es";
import { useConfigurationDelayCodeContext } from "../../context/ConfigurationDelayCodeContext";
import { CatalogDelayCode } from "../../models/CatalogDelayCode";
import { getDelays } from "../../repositories/ConfigurationDelayRepository";
import { TransformDelayModelData } from "../TransformDelayModelData";
type Props = {
	setSearchError: (err: string) => void;
	setAllDelayLoading: (loader: boolean) => void;
	includeInactive?: boolean;
};
export const useSearchDelays = ({
	setSearchError,
	setAllDelayLoading,
	includeInactive = false,
}: Props) => {
	const {
		actions: { setAllDelayNodes, setAllDelayCodes },
	} = useConfigurationDelayCodeContext();
	const searchDelays = async (assetId?: number) => {
		getDelays(assetId, includeInactive).then((res: any) => {
			if (res.ok) {
				const rows = get(res, "data.tables[0].rows", []);
				const mydataSource = rows.map((row: CatalogDelayCode) =>
					TransformDelayModelData(row),
				);

				setAllDelayCodes(rows);
				setAllDelayNodes(mydataSource);
				setAllDelayLoading(false);
			} else setSearchError(res.message);
		});
	};
	return { searchDelays };
};
